export type LocalizedText = {
  ar?: string;
  en?: string;
};

export type DonationSuccessSettings = {
  showSuggestedProjects: boolean;
  suggestedProjectsLimit: number;
  suggestedProjectsTitle: LocalizedText;
  title: LocalizedText;
  message: LocalizedText;
  pendingTitle: LocalizedText;
  pendingMessage: LocalizedText;
  bankTransferPendingTitle: LocalizedText;
  bankTransferPendingMessage: LocalizedText;
  failedTitle: LocalizedText;
  failedMessage: LocalizedText;
  showConfetti: boolean;
  showOperationCode: boolean;
  showCopyButton: boolean;
  showReceiptButton: boolean;
  showHomeButton: boolean;
  showRating: boolean;
  ratingRequired: boolean;
  ratingPrompt: LocalizedText;
  hideBankAccountsOnReceipt: boolean;
  successAnimationUrl: string;
  firePurchaseTracking: boolean;
};

export const DEFAULT_DONATION_SUCCESS_SETTINGS: DonationSuccessSettings = {
  showSuggestedProjects: true,
  suggestedProjectsLimit: 12,
  suggestedProjectsTitle: {},
  title: {},
  message: {},
  pendingTitle: {},
  pendingMessage: {},
  bankTransferPendingTitle: {},
  bankTransferPendingMessage: {},
  failedTitle: {},
  failedMessage: {},
  showConfetti: true,
  showOperationCode: true,
  showCopyButton: true,
  showReceiptButton: true,
  showHomeButton: true,
  showRating: true,
  ratingRequired: false,
  ratingPrompt: {},
  hideBankAccountsOnReceipt: true,
  successAnimationUrl: "/icons/successDonationIcon.json",
  firePurchaseTracking: true,
};

export function localizedSetting(
  value: LocalizedText | undefined,
  locale: string,
): string | undefined {
  const selected = locale === "ar" ? value?.ar : value?.en;
  return selected?.trim() || undefined;
}
